export default __webpack_public_path__ + "static/media/oats_smoothie.195fc464.jpg";